import { SortOrder } from "antd/lib/table/interface";

const getSortOrder = (column: string, ordering?: string): SortOrder => {
  if (ordering === null || ordering === undefined) {
    return null;
  }
  if (ordering.match(`^(-)?${column}$`)) {
    return ordering.startsWith("-", 0) ? "descend" : "ascend";
  }
  return null;
};

/** Format number with space as thousand delimiter.
 * 1123456.23 -> 1 123 456.23
 * 123456.00 -> 123 456
 * */
const formatNumber = (num: number, fractionDigits: number = 2): string => {
  return num
    ?.toFixed(fractionDigits)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ") // separate thousand
    .replace(/\.0+$/, "");
};

export { getSortOrder, formatNumber };
